export const fileViewerEn = {
  fileCannotBeViewed: 'The file cannot be viewed',
  downloadFile: 'Download file',
  fileLoading: 'File loading...'
}

export const fileViewerRu: typeof fileViewerEn = {
  fileCannotBeViewed: 'Просмотр файла невозможен',
  downloadFile: 'Скачать файл',
  fileLoading: 'Загрузка файла...'
}
